import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const ThemeContext = createContext();

const STORAGE_KEY = 'darkMode';

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

const readInitialDarkMode = () => {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === null) return true;
    return stored === 'true';
  } catch {
    return true;
  }
};

export const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(readInitialDarkMode);

  useEffect(() => {
    document.documentElement.dataset.bsTheme = isDarkMode ? 'dark' : 'light';
  }, [isDarkMode]);

  const setDarkMode = useCallback((next) => {
    setIsDarkMode(next);
    try {
      window.localStorage.setItem(STORAGE_KEY, String(next));
    } catch {
      // localStorage unavailable (private mode, quota) — in-memory only
    }
    // TODO: persist to backend once the user-preferences endpoint is available
  }, []);

  return (
    <ThemeContext.Provider value={{ isDarkMode, setDarkMode }}>
      {children}
    </ThemeContext.Provider>
  );
};
